import { Subscription } from "rxjs";
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { ResponsePaging } from '../../../shared/nestjs/nest-responses';
import { Injectable } from '@angular/core';
import { MakeIdCardApiProvider } from "../../../shared/nestjs/make-id-card/make-id-card-api";
import { EmployeesApi } from "../../../shared/nestjs/gd-only/services/employees.api";
import { RequestGetEmpDto } from "../../../shared/nestjs/gd-only/dto/employees.dto";

@Injectable()
export class IdCardBloc {
	private subscriptions: Array<Subscription> = [];

	constructor(
		public nestApiProvider: NestApiProvider,
		private makeIdCardApi: MakeIdCardApiProvider,
		private employeesApi: EmployeesApi
	) {

	}

	dispose() {
		this.subscriptions.forEach(subs => subs.unsubscribe());
	}

	getEmployee(payload: RequestGetEmpDto, queryParams: { page: number, limit: number }) {
		return new Promise<ResponsePaging<any>>((resolve, reject) => {
			this.subscriptions.push(
				this.employeesApi.getEmp(payload, queryParams)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)

		})
	}

	saveIdCard(payload) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.makeIdCardApi.saveIdCard(payload)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

}



// WEBPACK FOOTER //
// ./src/bloc/feature/id-card/id-card.bloc.ts